import L from 'leaflet';

if (!Array.prototype.permutations)
    Object.defineProperty(Array.prototype, 'permutations', {
        value: function permutations<T>(this: T[]): T[][] {
            return [...(function* permute(k: number, arr: T[]) {
                if (k === 1) yield arr.slice();
                else {
                    yield* permute(k - 1, arr);

                    for (let i = 0; i < k - 1; i++) {
                        if (k % 2 === 0) [arr[i], arr[k - 1]] = [arr[k - 1], arr[i]];
                        else [arr[0], arr[k - 1]] = [arr[k - 1], arr[0]];
                        yield* permute(k - 1, arr);
                    }
                }
            })(this.length, this.slice())];
        },
    });

if (!Array.prototype.shuffle)
    Object.defineProperty(Array.prototype, 'shuffle', {
        value: function shuffle<T>(this: T[]): T[] {
            for (let i = this.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this[i], this[j]] = [this[j], this[i]];
            }
            return this;
        },
    });

if (!Array.prototype.uniqueBy)
    Object.defineProperty(Array.prototype, 'uniqueBy', {
        value: function uniqueBy<T>(this: T[], f: (t: T) => number | string | symbol): T[] {
            const seen = {};
            return this.filter(t => {
                const key = f(t);
                const hasBeenSeen = key in seen;
                seen[key] = t;
                return hasBeenSeen;
            })
        },
    });

if (!Array.prototype.windows)
    Object.defineProperty(Array.prototype, 'windows', {
        value: function windows<T>(this: T[], n: number): T[][] {
            if (n <= 0) return [];
            if (n >= this.length) return [this];
            return this.zip(...Array(n - 1).fill(null).map((_, i) => this.slice(i + 1)));
        },
    });

if (!Array.prototype.zip)
    Object.defineProperty(Array.prototype, 'zip', {
        value: function zip<T>(this: T[], ...rest: T[][]): T[][] {
            const that = this;
            return [...(function* () {
                const arrays: T[][] = [that, ...rest];
                const min = Math.min(...arrays.map(arr => arr.length));

                for (let i = 0; i < min; i++)
                    yield arrays.map(arr => arr[i]);
            })()];
        },
    });

export function exprToTuple(p: L.LatLngExpression): L.LatLngTuple {
    return [
        (p as L.LatLng)?.lat || (p as L.LatLngTuple)[0],
        (p as L.LatLng)?.lng || (p as L.LatLngTuple)[1],
    ];
}
export function preventDefault<T extends { preventDefault(): void }>(f: ($e: T) => void): ($e: T) => void {
    return $e => {
        $e.preventDefault();
        f($e);
    };
}

